import CallToActionComponent from "@/components/Button";
import { forwardRef } from "react";
import styled from "styled-components";
import { SVGArrowBottom as SVGArrowBottomComponent } from "@/lib/svg";

// Cast to fix React 17 + @types/react 18 compatibility issue
const CallToAction = CallToActionComponent as any;
const SVGArrowBottom = SVGArrowBottomComponent as any;

export const Icon = styled(SVGArrowBottom as any)`
  font-size: 0.6em;
`;

const _Button = forwardRef<HTMLButtonElement, any>((props, ref) => {
  const CallToActionTyped = CallToAction as any;
  return (
    <CallToActionTyped
      ref={ref}
      variant="primaryBoxed"
      icon={<Icon />}
      {...props}
    />
  );
});

_Button.displayName = "Button";

export const Button = styled(_Button as any)`
  margin: 5rem auto 0;
  width: max-content;
  cursor: pointer;
  display: flex;
  align-items: center;
`;
